import React from "react";
import UseContext from "hooks/useContext";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import LoadingButton from "components/button/loading";

const PerimeterModalFooter = ({
    confirmLabel,
    savingLabel,
    isSaving,
    canConfirm = true,
    onCancel,
    onConfirm,
}) => {
    const { language } = UseContext();

    return (
        <ModalFooter>
            <Button size="LG" color="SECONDARY" onClick={onCancel}>
                {language.getValue("perimeters.modal.cancel")}
            </Button>
            {isSaving ? (
                <LoadingButton color="PRIMARY" size="LG">{savingLabel}</LoadingButton>
            ) : (
                <Button
                    size="LG"
                    color={canConfirm ? "PRIMARY" : "DISABLED"}
                    disabled={!canConfirm}
                    onClick={onConfirm}
                >
                    {confirmLabel}
                </Button>
            )}
        </ModalFooter>
    );
};

export default PerimeterModalFooter;
